<template>
  <div class="flex flex-col justify-center items-center">
    <!-- Logo -->
    <div
      v-motion
      class="relative h-12 w-12 sm:h-14 sm:w-14 bg-slate-400 dark:bg-slate-500/50 rounded-full flex items-center justify-center mb-4"
      :initial="{ opacity: 0, y: -16 }"
      :enter="{ opacity: 1, y: 0 }"
      :duration="300"
    >
      <ChatBubbleOvalLeftIcon class="h-6 w-6 stroke-[3] text-white" />
    </div>
    <div
      v-motion
      class="bg-surface-200 dark:bg-surface-700 rounded-[50%] blur-[1px]"
      :initial="{ height: 4, width: 12 }"
      :enter="{ height: 12, width: 48 }"
      :duration="300"
    />
    <!-- Content -->
    <div class="flex flex-col items-center relative z-10 max-w-xs mt-4">
      <h2
        class="h4 text-center leading-tight mb-2 opacity-0 animate-[fade-in_0.3s_0.3s_ease-in_forwards]"
      >
        {{ $t("noRecentConversationsTitle") }}
      </h2>
      <p
        class="max-w-lg text-center opacity-0 animate-[fade-in_0.6s_0.4s_ease-in_forwards] ma-text-secondary"
      >
        {{ $t("noRecentConversationsDescription") }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChatBubbleOvalLeftIcon } from "@heroicons/vue/24/outline";
</script>
